import { labeled, emailOptional, phoneCodeRequired, phoneNumberRequired } from '../../util/joi';
import { schema as preferredContactMethodSchema } from './ContactPreferredContactMethod.schema';
import { schema as addressSchema } from '../address/Address.schema';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    phoneCode: phoneCodeRequired(Joi).label(labeled(label, 'Phone code')),
    phone: phoneNumberRequired(Joi).label(labeled(label, 'Phone number')),
    email: emailOptional(Joi).label(labeled(label, 'E-Mail address')),
    preferredContactMethod: preferredContactMethodSchema(
      Joi,
      labeled(label, 'Preferred contact method -')
    ),
    address: addressSchema(Joi, labeled(label, 'Address -')),
    registeredAddress: addressSchema(Joi, labeled(label, 'Registered address -')),
    mailingAddress: addressSchema(Joi, labeled(label, 'Mailing address -'))
  });

export default {
  schema
};
